import { getTwoPointParameters } from "./get-point-parameter.js";
import { guard, isPoint3d } from "./guard.js";
/**
 * Returns a Point with the x,y,z values of two points added.
 *
 * `z` parameter is used, if present. Uses a default value of 0 for 'z' when adding a 2D point with a 3D one.
 *
 * Examples:
 *
 * ```js
 * sum(ptA, ptB);
 * sum(x1, y1, x2, y2);
 * sum(ptA, x2, y2);
 * ```
 */
export function sum(a1, ab2, ab3, ab4, ab5, ab6) {
    const [ptA, ptB] = getTwoPointParameters(a1, ab2, ab3, ab4, ab5, ab6);
    guard(ptA, `a`);
    guard(ptB, `b`);
    const pt = {
        x: ptA.x + ptB.x,
        y: ptA.y + ptB.y,
    };
    if (isPoint3d(ptA) || isPoint3d(ptB)) {
        pt.z = (ptA.z ?? 0) + (ptB.z ?? 0);
    }
    ;
    return Object.freeze(pt);
}
;
